var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _g, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKingSection2Icon1 = function SvgKingSection2Icon1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.08 62.827H35.676a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865H53.08c.477 0 .864.388.864.864v1.045a.864.864 0 0 1-.864.864Z",
    fill: "#08F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.08 60.054H35.676a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865H53.08c.477 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.864Z",
    fill: "#33A0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.08 57.282H35.676a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.865.864-.865H53.08c.477 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.864Z",
    fill: "#08F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.542 9.375H43.476c-.848 0-1.536.687-1.536 1.536v59.832c0 .849.688 1.537 1.536 1.537h35.651c5.496 0 9.951-4.456 9.951-9.952V10.911c0-.849-.688-1.536-1.536-1.536Z",
    fill: "#CFDDE9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 48.963H96.498a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.044a.864.864 0 0 1-.865.865Z",
    fill: "#08F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 46.19H96.498a.864.864 0 0 1-.864-.864V44.28c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.045a.864.864 0 0 1-.865.864Z",
    fill: "#33A0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 43.417H96.498a.864.864 0 0 1-.864-.864v-1.045c0-.477.387-.864.864-.864h17.404c.478 0 .865.388.865.864v1.045a.864.864 0 0 1-.865.864Z",
    fill: "#08F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 40.644H96.498a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .865.388.865.865v1.044a.864.864 0 0 1-.865.864Z",
    fill: "#33A0FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 60.054H96.498a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .865.388.865.865v1.044a.864.864 0 0 1-.865.864Z",
    fill: "#08F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 57.282H96.498a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .865.388.865.865v1.044a.864.864 0 0 1-.865.864Z",
    fill: "#33A0FF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 54.509H96.498a.864.864 0 0 1-.864-.865V52.6c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.044a.864.864 0 0 1-.865.865Z",
    fill: "#08F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 51.736H96.498a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.044a.864.864 0 0 1-.865.865Z",
    fill: "#33A0FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.33 68.373h-17.404a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.404c.478 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865Z",
    fill: "#08F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.33 65.6h-17.404a.864.864 0 0 1-.864-.864V63.69c0-.477.387-.864.864-.864h17.404c.478 0 .864.387.864.864v1.045a.864.864 0 0 1-.864.864Z",
    fill: "#33A0FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.33 62.827h-17.404a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .864.388.864.864v1.045a.864.864 0 0 1-.864.864Z",
    fill: "#08F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.33 60.054h-17.404a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.864Z",
    fill: "#33A0FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.33 57.282h-17.404a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .864.388.864.865v1.044a.864.864 0 0 1-.864.864Z",
    fill: "#08F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.33 54.509h-17.404a.864.864 0 0 1-.864-.865V52.6c0-.477.387-.864.864-.864h17.404c.478 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 68.373H96.498a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.044a.864.864 0 0 1-.865.865Z",
    fill: "#33A0FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 65.6H96.498a.864.864 0 0 1-.864-.864V63.69c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.045a.864.864 0 0 1-.865.864Z",
    fill: "#08F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.902 62.827H96.498a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .865.388.865.864v1.045a.864.864 0 0 1-.865.864Z",
    fill: "#33A0FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.652 60.054H15.248a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .865.388.865.865v1.044a.864.864 0 0 1-.865.864Z",
    fill: "#08F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.652 57.282H15.248a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .865.388.865.865v1.044a.864.864 0 0 1-.865.864Z",
    fill: "#33A0FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.652 54.509H15.248a.864.864 0 0 1-.864-.865V52.6c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.044a.864.864 0 0 1-.865.865Z",
    fill: "#08F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.652 51.736H15.248a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.044a.864.864 0 0 1-.865.865Z",
    fill: "#33A0FF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.08 68.373H35.676a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864H53.08c.477 0 .864.387.864.864v1.044a.864.864 0 0 1-.864.865Z",
    fill: "#08F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.08 65.6H35.676a.864.864 0 0 1-.864-.864V63.69c0-.477.387-.864.864-.864H53.08c.477 0 .864.387.864.864v1.045a.864.864 0 0 1-.864.864ZM32.652 68.373H15.248a.864.864 0 0 1-.864-.865v-1.044c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.044a.864.864 0 0 1-.865.865Z",
    fill: "#33A0FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.652 65.6H15.248a.864.864 0 0 1-.864-.864V63.69c0-.477.387-.864.864-.864h17.404c.478 0 .865.387.865.864v1.045a.864.864 0 0 1-.865.864Z",
    fill: "#08F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.652 62.827H15.248a.864.864 0 0 1-.864-.864v-1.044c0-.477.387-.865.864-.865h17.404c.478 0 .865.388.865.864v1.045a.864.864 0 0 1-.865.864Z",
    fill: "#33A0FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "king-section2-icon-1_svg__a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 61,
    width: 51,
    height: 12
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.375 61.563h50.04V72.29h-50.04V61.563Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#king-section2-icon-1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.375 61.563h39.377s.021 10.717 10.663 10.717H40.007S29.375 73 29.375 61.563Z",
    fill: "#B3C3CE"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.426 35.432H47.434a.957.957 0 0 1-.958-.957v-.067c0-.529.43-.957.958-.957h34.992c.528 0 .957.428.957.957v.067a.957.957 0 0 1-.957.957ZM82.426 21.72H67.097a.958.958 0 0 1-.957-.957v-.067c0-.53.429-.957.957-.957h15.329c.528 0 .957.428.957.957v.066a.958.958 0 0 1-.957.958ZM82.426 28.34H67.097a.958.958 0 0 1-.957-.958v-.067c0-.529.429-.957.957-.957h15.329c.528 0 .957.428.957.957v.067a.958.958 0 0 1-.957.958ZM82.426 42.403H47.434a.958.958 0 0 1-.958-.957v-.067c0-.529.43-.957.958-.957h34.992c.528 0 .957.428.957.957v.067a.958.958 0 0 1-.957.957ZM82.426 49.335H47.434a.958.958 0 0 1-.958-.956v-.068c0-.528.43-.957.958-.957h34.992c.528 0 .957.429.957.957v.068a.958.958 0 0 1-.957.956ZM82.426 56.114H47.434a.957.957 0 0 1-.958-.957v-.067c0-.528.43-.957.958-.957h34.992c.528 0 .957.429.957.957v.067a.957.957 0 0 1-.957.957Z",
    fill: "#B3C3CE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.574 62.827c0 6.368-5.162 11.53-11.53 11.53-6.368 0-11.53-5.162-11.53-11.53 0-6.367 5.162-11.53 11.53-11.53 6.368 0 11.53 5.163 11.53 11.53Z",
    fill: "#33A0FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.284 63.75c0 .773.05 1.579.034 2.368.688.084 1.393-.437 1.309-1.193-.067-.587-.772-1.023-1.343-1.175Zm-2.787-2.77c.201.135.504.202.84.252v-1.897c-.74.033-1.31.336-1.193 1.091.017.168.168.42.353.554Zm.906 8.076c-.05-.084-.05-.924-.067-.924-.52-.067-1.276-.184-1.796-.37-.672-.267-1.545-.553-1.83-1.258-.235-.52-.135-1.326.52-1.477.47-.135.856.386 1.26.587.503.202 1.276.386 1.846.47v-2.921c-.403-.134-.99-.252-1.293-.336-.285-.118-.52-.185-.704-.285-.47-.185-.857-.504-1.075-.89a2.62 2.62 0 0 1-.336-1.31c0-.436.1-.84.235-1.175a2.21 2.21 0 0 1 .655-.873c.268-.27.621-.437 1.024-.605.386-.167 1.041-.252 1.494-.302 0-.302-.05-.688.135-.94.269-.37.436-.52.873-.487.402.033.738.168.89.571.016.084.05.906.05.906.722.152 1.545.387 2.166.74.487.301.823.67.806 1.258-.017.32-.269.672-.588.706-.353.033-.672-.185-.957-.336-.386-.168-.923-.403-1.427-.453v2.317c.47.134 1.041.386 1.41.537 1.243.503 1.847 1.746 1.797 3.005a3.18 3.18 0 0 1-.252 1.176 3.129 3.129 0 0 1-.671.805c-.27.235-.588.403-.957.57-.37.118-.89.22-1.327.303-.05 0-.017.689 0 .756 0 .168-.05.37-.118.487-.42.588-1.578.52-1.763-.252Z",
    fill: "#fff"
  })));
};
export default SvgKingSection2Icon1;